export const SEASONAL_SUMMER_START_MONTH = 4
export const SEASONAL_WINTER_START_MONTH = 10
